export default __webpack_public_path__ + "static/media/placeholder.1287f47e.jpg";